
function Churches() {

    return (
        <div>
            <main>
                <section>
                    <div className="banner">
                        <img className='header-image' src="/assets/city-img/church_banner.JPG" alt="Kirche" />
                    </div>
                </section>
                <div className="content">
                    <article>
                        <div className="text">
                            <h1>Wismars Kirchen</h1>
                            <p>Wusstest du, dass die Anzahl der Kirchen einer Stadt im Mittelalter für den Reichtum dieser 
                                stand? Wismar besitzt gleich 4 Stück davon und war zur Zeit der Hanse im 13. Jhd. eine 
                                wohlhabende Stadt. Die sakralen Bauten zeugen noch heute davon.
                            </p>
                        </div>
                        <div className="text">
                            <h2>St. Georgen</h2>
                            <p>Im 13. Jhd. errichtet und nach gut 300 Jahren in ihrer Gänze fertiggestellt, 
                                ist die St. Georgen Kirche ein imposantes Bauwerk, das mit ihrer Wiedereröffnung 
                                2010 bestaunt und erkundet werden kann.<br></br>In nur 8 Gehminuten vom Apartment 5 
                                zu erreichen, fügt sich die Kirche nahtlos in die südwestliche Altstadt ein. Auf 
                                der Aussichtsplattform lässt sich Wismar auch von oben erkunden.
                            </p>
                        </div>
                        <div className="text">
                            <h2>St. Nikolai</h2>
                            <p>Im 14. und 15. Jhd. erbaut, gehört die Nikolaikirche im kleinen Städtchen Wismar zu 
                                einer der größten Kirchen in Mitteleuropa. Direkt an der Frischen Grube gelegen, 
                                lässt sich das längst vergangene Jahrhundert der Zeitgeschichte optisch auf einzigartige 
                                Weise nachvollziehen.<br></br>Zwischen heutigem Bahnhof und Markplatz positioniert, kann 
                                man das Bauwerk keinesfalls verfehlen. Der Bürgersteig schmiegt sich eng an die hohen Mauern, 
                                Turm und Kirchenschiff lassen sich aufgrund der Höhe mehr erahnen als in ihrer Gesamtheit 
                                mit den eigenen Augen erfassen. Einfach ein beeindruckendes Bauwerk und unbedingt einen 
                                Besuch wert.
                            </p>
                        </div>
                        <div className="text">
                            <h2>St. Marien</h2>
                            <p>Ebenfalls im 13. Jhd. errichtet aber heute nur noch in Form des Kirchturms vorhanden: 
                                die Marienkirche. Das Kirchenschiff, das in der Mitte des letzten Jahrhunderts gesprengt 
                                wurde, ist heute nachempfunden. Die Maße lassen auch hier die Dimensionen des ursprünglichen 
                                Bauwerks erahnen.<br></br>Der Turm ist vom Apartment 5 aus zu sehen, die Turmuhr eignet sich 
                                auch in heutigen digitalen Zeiten als praktischer Zeitanzeiger bei Auszeiten auf dem Dach.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Heiligen Geist</h2>
                            <p>Auch hier reicht die Errichtung ins 13. Jhd. zurück. Im Gegensatz zu den anderen drei Kirchen 
                                diente die Heiligen-Geist-Kirche als Spitalkirche und ist von außen auf den ersten Blick kaum 
                                als typische Kirche erkennbar. Sich einfügend in die umgebenden Bauten, ist es auch der 
                                Innenhof mit Garten, der diese Kirche zu einem sehenswerten architektonischen Idyll macht.
                                <br></br>Berühmtheit erlangte der Innenhof mit einem der ersten Horrorfilme namens Nosferatu, der 
                                an einigen Schauplätzen in Wismar 1921 gedreht wurde, unter anderem auch hier.
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    )
}

export default Churches;